export const buildStringFromArray = (array) => {
  if (typeof array !== "object") return;
  const cleanedArray = array.filter((value) => typeof value === "string");
  return cleanedArray;
};

export const makeid = (length) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
  }
  return result;
}

export const renderPosition = (position) => {
  const ones = position % 10;
  const tens = Math.floor(position / 10) % 10;

  if (tens === 1) {
    return `${position}th`;
  } else {
    switch (ones) {
      case 1:
        return `${position}st`;
      case 2:
        return `${position}nd`;
      case 3:
        return `${position}rd`;
      default:
        return `${position}th`;
    }
  }
};

export const camelCaseToSnakeCase = (string) => {
  return string.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
}

export const snakeCaseToCamelCase = (string) => {
  return string.replace(/_([a-z])/g, (match, char) => char.toUpperCase());
};

export const snakeCaseToTitleCase = (string) => {
  return string
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const mapErrorsFromForm = (errors) => {
  return errors?.map((error) => error);
};

export function truncateText(text, maxLength) {
    if (text.length <= maxLength) {
        return text
    } else {
        return text.slice(0, maxLength) + "..."
    }
}


export const getFirstWallet = (wallets) => {
  if (wallets.length === 0) return;
  return truncateText(wallets[0].address, 10);
};

export const  generateRandomBigInt = (lowBigInt, highBigInt) => {
  const min = BigInt(lowBigInt);
  const max = BigInt(highBigInt);

  if (min >= max) {
    throw new Error("lowBigInt must be smaller than highBigInt");
  }

  const range = max - min + BigInt(1);
  const randomBigInt = BigInt(Math.floor(Math.random() * Number(range)));

  return min + randomBigInt;
}